/* eslint-disable @typescript-eslint/no-unused-vars */
function checkWords(sentence, notInclude, isInclude) {
  // Check if all words from notInclude are not in the sentence
  const notIncludeCheck = notInclude.every(
    word => !new RegExp(`\\b${word}\\b`, 'i').test(sentence)
  );

  // Check if any word from isInclude is in the sentence
  const isIncludeCheck = isInclude.some(word =>
    new RegExp(`\\b${word}\\b`, 'i').test(sentence)
  );

  console.table({
    sentence,
    notInclude,
    isInclude,
    notIncludeCheck,
    isIncludeCheck
  });

  // Return true if both checks pass, otherwise return false
  return notIncludeCheck && isIncludeCheck;
}

function isValidGSTNo(str) {
  // Regex to check valid GST CODE
  let regex = new RegExp(
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
  );
  return regex.test(str);
}

const dataModal = [
  {
    id: '1',
    question: 'Is the Vendor Name correct?',
    questionType: 'VENDOR_NAME',
    answer: '',
    label: 'Vendor Name',
    type: 'NAME',
    textType: 'VENDOR'
  },
  {
    id: '2',
    question: 'Is the Vendor Address correct?',
    questionType: 'VENDOR_ADDRESS',
    answer: '',
    label: 'Vendor Address',
    type: 'ADDRESS',
    textType: 'VENDOR'
  },
  //   {
  //     id: '3',
  //     question: 'Is the Vendor Phone correct?',
  //     questionType: 'VENDOR_PHONE',
  //     answer: '',
  //     label: 'Vendor Phone',
  //     type: 'VENDOR_PHONE'
  //   },
  {
    id: '4',
    question: 'Is the PAN No. correct?',
    questionType: 'TAX_PAYER_ID',
    answer: '',
    label: 'PAN No.',
    labelInclude: 'pan',
    type: 'TAX_PAYER_ID'
  },
  {
    id: '5',
    question: 'Is the Vendor GST No. correct?',
    questionType: 'VENDOR_GST_NUMBER',
    answer: '',
    label: 'Vendor GST No.',
    type: 'VENDOR_GST_NUMBER'
  },
  //   {
  //     id: '6',
  //     question: 'Is the Vendor Email correct?',
  //     questionType: 'VENDOR_EMAIL',
  //     answer: '',
  //     label: 'Vendor Email',
  //     type: 'VENDOR_EMAIL'
  //   },
  {
    id: '7',
    question: 'Is the Receiver Name correct?',
    questionType: 'RECEIVER_NAME',
    answer: '',
    label: 'Receiver Name',
    type: 'RECEIVER_NAME'
  },
  //   {
  //     id: '8',
  //     question: 'Is the Receiver Address correct?',
  //     questionType: 'RECEIVER_ADDRESS',
  //     answer: '',
  //     label: 'Receiver Address',
  //     type: 'RECEIVER_ADDRESS'
  //   },
  {
    id: '9',
    question: 'Is the Receiver GST No. correct?',
    questionType: 'RECEIVER_GST_NUMBER',
    answer: 'Inv-123',
    label: 'Receiver GST No.',
    type: 'RECEIVER_GST_NUMBER'
  },
  {
    id: '10',
    question: 'Is the Invoice No. correct?',
    questionType: 'INVOICE_RECEIPT_ID',
    answer: '',
    label: 'Invoice No.',
    type: 'INVOICE_RECEIPT_ID'
  },
  {
    id: '11',
    question: 'Is the Invoice Date correct?',
    questionType: 'INVOICE_RECEIPT_DATE',
    answer: '',
    label: 'Invoice Date',
    type: 'INVOICE_RECEIPT_DATE'
  },
  //   {
  //     id: '12',
  //     question: 'Is the Receiver Address correct?',
  //     questionType: 'ADDRESS_BLOCK',
  //     answer: '',
  //     label: 'Receiver Address',
  //     type: 'ADDRESS_BLOCK',
  //     textType: 'RECEIVER'
  //   },
  {
    id: '13',
    question: 'Is the Total correct?',
    questionType: 'TOTAL',
    answer: '',
    label: 'Total',
    type: 'TOTAL',
    labelNotInclude: ['Sub', 'word'],
    labelInclude: 'Total',
    secondTry: true
  },
  {
    id: '14',
    question: 'Is the CGST correct?',
    questionType: 'TAX',
    answer: '',
    label: 'CGST',
    type: 'TAX',
    labelInclude: 'CGST'
  },
  {
    id: '15',
    question: 'Is the SGST correct?',
    questionType: 'TAX',
    answer: '',
    label: 'SGST',
    type: 'TAX',
    labelInclude: 'SGST'
  },
  {
    id: '16',
    question: 'Is the IGST correct?',
    questionType: 'TAX',
    answer: '',
    label: 'IGST',
    type: 'TAX',
    labelInclude: 'IGST'
  },
  //   {
  //     id: '17',
  //     question: 'Is the Round Off correct?',
  //     questionType: 'ROUND_OFF',
  //     answer: '',
  //     label: 'Round Off',
  //     type: 'ROUND_OFF'
  //   },
  //   {
  //     id: '18',
  //     question: 'Is the Discount correct?',
  //     questionType: 'DISCOUNT',
  //     answer: '',
  //     label: 'Discount',
  //     type: 'DISCOUNT'
  //   },
  {
    id: '19',
    question: 'Is the Sub Total correct?',
    questionType: 'SUBTOTAL',
    answer: '',
    label: 'Taxable Value',
    type: 'SUBTOTAL',
    labelInclude: 'taxable'
  }
  //   {
  //     id: '20',
  //     question: 'Is the Amount In Word correct?',
  //     questionType: 'TOTAL_IN_WORD',
  //     answer: '',
  //     label: 'Amount In Word',
  //     type: 'TOTAL_IN_WORD'
  //   },
  //   {
  //     id: '21',
  //     question: 'Are the GST Rates correct?',
  //     questionType: 'BANK_DETAIL',
  //     answer: '',
  //     label: 'Bank Detail',
  //     type: 'BANK_DETAIL:'
  //   }
];

export function filterInvoiceData(billData) {
  const typeData = {};
  const billItems = [];
  let isGstBill = false;
  let taxCount = 1;

  //Demo- print all data in console
  let sampleData = [];
  billData?.[0]?.['SummaryFields'].map((invoice, i) => {
    let data = {};
    data['GroupProperties'] = invoice?.GroupProperties?.[0]?.Types?.[0];
    data['LabelDetection'] = invoice?.LabelDetection?.Text;
    data['Type'] = invoice?.Type?.['Text'];
    data['ValueDetection'] = invoice?.ValueDetection?.['Text'];

    sampleData.push(data);
  });

  console.table(sampleData);
  //Demo- print all data in console

  // checking this bill is gstBill or not
  isGstBill = billData?.[0]?.['SummaryFields'].some(item =>
    isValidGSTNo(item?.ValueDetection?.['Text'])
  );

  try {
    billData?.[0]?.['LineItemGroups'][0]['LineItems'].forEach((item, i) => {
      let multipleOther = 1;
      const lineItems = {};

      for (let j = 0; j < item['LineItemExpenseFields'].length - 1; j++) {
        const currentInvItem = item['LineItemExpenseFields'][j];
        if (currentInvItem['Type']['Text'] === 'OTHER') {
          lineItems[
            `${currentInvItem['Type']['Text']} ${
              multipleOther === 1 ? '' : multipleOther
            }`
          ] = currentInvItem['ValueDetection']['Text'];
          multipleOther++;
        } else {
          lineItems[currentInvItem['Type']['Text']] =
            currentInvItem['ValueDetection']['Text'];
        }
      }

      billItems.push(lineItems);
    });
  } catch (err) {
    console.log('This is bill item error', err);
  }

  const formingData = dataModal?.map((item, i) => {
    let copyItem = { ...item };

    const findObj = billData?.[0]?.['SummaryFields'].find((bill, j) => {
      if (item.labelNotInclude) {
        if (bill?.Type?.Text === item.type) {
          if (bill?.LabelDetection?.Text) {
            if (
              checkWords(
                (bill?.LabelDetection?.Text || '').toLowerCase(),
                [...item.labelNotInclude],
                [item.labelInclude]
              )
            ) {
              copyItem['answer'] = bill?.ValueDetection?.Text;
              copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

              return true;
            }
          } else {
            copyItem['answer'] = bill?.ValueDetection?.Text;
            copyItem['accuracy'] = bill?.ValueDetection?.Confidence;
          }
        }
      } else if (item.labelInclude) {
        if (
          bill?.Type?.Text === item.type &&
          bill?.LabelDetection?.Text?.toLowerCase()?.includes(
            item.labelInclude?.toLowerCase()
          )
        ) {
          copyItem['answer'] = bill?.ValueDetection?.Text;
          copyItem['accuracy'] = bill?.ValueDetection?.Confidence;
          if (item.type === 'TAX') {
            copyItem['label'] = bill?.LabelDetection?.Text;
          }

          return true;
        } else if (
          ('TAX_PAYER_ID' === item.type || 'SUBTOTAL' === item.type) &&
          bill?.Type?.Text === item.type
        ) {
          copyItem['answer'] = bill?.ValueDetection?.Text;
          copyItem['accuracy'] = bill?.ValueDetection?.Confidence;
        } else if ('SUBTOTAL' === item.type) {
          if (
            bill?.LabelDetection?.Text?.toLowerCase()?.includes(
              item.labelInclude?.toLowerCase()
            )
          ) {
            copyItem['answer'] = bill?.ValueDetection?.Text;
            copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

            return true;
          }
        }
      } else if (item.textType) {
        if (bill?.GroupProperties) {
          if (
            bill?.GroupProperties[0].Types[0] === item.textType &&
            bill?.Type?.Text === item.type
          ) {
            copyItem['answer'] = bill?.ValueDetection?.Text;
            copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

            return true;
          }
        } else if (bill?.Type?.Text === item.type) {
          copyItem['answer'] = bill?.ValueDetection?.Text;
          copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

          return true;
        }
      } else if (bill?.Type?.Text === item.type) {
        copyItem['answer'] = bill?.ValueDetection?.Text;
        copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

        return true;
      } else {
        copyItem['answer'] = '';
        copyItem['accuracy'] = 0;

        return false;
      }
    });

    if (item.secondTry && copyItem?.answer?.length === 0) {
      billData?.[0]?.['SummaryFields'].find(bill => {
        if (bill?.Type?.Text === item.type) {
          if (bill?.ValueDetection?.Text?.length > 0) {
            copyItem['answer'] = bill?.ValueDetection?.Text;
            copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

            return true;
          }
        }
      });
    }

    if (copyItem.type === 'TAX') {
      typeData[`${copyItem.type}${taxCount}`] = copyItem;
      taxCount++;
    } else {
      typeData[copyItem.type] = copyItem;
    }

    return copyItem;
  });

  return {
    invoiceItem: billItems,
    filteredData: billData?.length > 0 ? typeData : {},
    data: billData,
    isGstBill
  };
}
